import { z } from "zod";
// ─── Standard API Error Response ───────────────────────────
export const ApiErrorResponseSchema = z.object({
    error: z.object({
        code: z.string(),
        message: z.string(),
        details: z.unknown().optional(),
        requestId: z.string().uuid(),
    }),
});
// ─── Pagination ────────────────────────────────────────────
export const PaginationQuerySchema = z.object({
    limit: z.coerce.number().int().min(1).max(100).default(50),
    offset: z.coerce.number().int().min(0).default(0),
});
// ─── ID Param ──────────────────────────────────────────────
export const IdParamSchema = z.object({
    id: z.string().uuid(),
});
// ─── Tenant ────────────────────────────────────────────────
export const TenantSchema = z.object({
    id: z.string().min(1).max(50),
    name: z.string().min(1).max(200),
    slug: z
        .string()
        .min(1)
        .max(50)
        .regex(/^[a-z0-9-]+$/),
    domain: z.string().max(253).optional(),
    clerkOrgId: z.string().optional(),
    currency: z.string().length(3).default("GBP"),
    theme: z
        .object({
        primaryColor: z.string().regex(/^#[0-9a-fA-F]{6}$/),
        accentColor: z.string().regex(/^#[0-9a-fA-F]{6}$/),
        sidebarBg: z.string().regex(/^#[0-9a-fA-F]{6}$/),
    })
        .optional(),
    createdAt: z.string().datetime(),
});
export const TenantConfigResponseSchema = z.object({
    id: z.string(),
    name: z.string(),
    slug: z.string(),
    currency: z.string(),
    theme: z
        .object({
        primaryColor: z.string(),
        accentColor: z.string(),
        sidebarBg: z.string(),
    })
        .optional(),
    clerkPublishableKey: z.string(),
});
// ─── Upload Token ──────────────────────────────────────────
export const UploadTokenResponseSchema = z.object({
    uploadUrl: z.string().url(),
    blobKey: z.string(),
    expiresAt: z.string().datetime(),
});
//# sourceMappingURL=common.js.map